import React, { Suspense } from 'react'
import { Switch, Route } from 'react-router'
const AriaViewerRouteHandler = React.lazy(() => import('./AriaViewerRouteHandler'))
import Settings from 'aria-viewer/settings'

export default (App, Analytics) => (
    <Suspense fallback={<div>Loading...</div>}>
        <Switch>
            <Route path="/settings" component={Settings} />
            <Route
                path="(/)?(/?tour)?/:inst_id/:loc_id?"
                render={props => (
                    <AriaViewerRouteHandler analytics={Analytics} {...props}>
                        <App />
                    </AriaViewerRouteHandler>
                )}
            />
        </Switch>
    </Suspense>
)
